var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevvDrinkware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6648 4H8.33149C8.14936 3.99999 7.96917 4.0367 7.80201 4.10788C7.63486 4.17906 7.48429 4.28319 7.35959 4.41385C7.23489 4.54452 7.13871 4.69895 7.07698 4.86761C7.01525 5.03628 6.98927 5.2156 7.00065 5.39453L8.33399 23.7695C8.35519 24.1028 8.50463 24.4156 8.75188 24.6442C8.99913 24.8728 9.3256 25 9.66482 25H20.3315C20.6707 25 20.9972 24.8728 21.2444 24.6442C21.4917 24.4156 21.6411 24.1028 21.6623 23.7695L22.9956 5.39453C23.007 5.2156 22.981 5.03628 22.9193 4.86761C22.8576 4.69895 22.7614 4.54452 22.6367 4.41385C22.512 4.28319 22.3614 4.17906 22.1943 4.10788C22.0271 4.0367 21.8469 3.99999 21.6648 4V4ZM21.6648 5.3125L21.2836 10.5625H8.71232L8.33149 5.3125H21.6648ZM9.66482 23.676L8.80774 11.875H21.1886L20.3315 23.6875L9.66482 23.676Z",
    fill: "#61A578"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 21,
    fill: "white",
    transform: "translate(7 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevvDrinkware);
export default __webpack_public_path__ + "static/media/revv_drinkware.26b5f2ade318fced4ea1b9c82a4f7ddd.svg";
export { ForwardRef as ReactComponent };